import { ChangeDetectionStrategy, Component, HostBinding, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'btn',
    standalone: true,
    imports: [Button, TranslateModule, TooltipModule],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
    id = input.required<string>();
    label = input.required<string>();

    icon = input<string>('');
    iconPos = input<'left' | 'right'>('left');

    tooltip = input<string>('');
    tooltipPosition = input<'bottom' | 'left' | 'right' | 'top'>('top');
    tooltipDisabled = input<boolean>(false);

    severity = input<'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast'>('primary');
    size = input<undefined | 'small' | 'large'>(undefined);
    rounded = input<boolean>(false);
    text = input<boolean>(false);
    outlined = input<boolean>(false);
    link = input<boolean>(false);
    fluid = input<boolean>(false);

    disabled = input<boolean>(false);
    loading = input<boolean>(false);

    class = input<string>('');
    style = input<Partial<CSSStyleDeclaration>>({});
    whiteBg = input<boolean>(false);

    // used to hande border radius if the button is glued to another element
    glueRight = input<boolean>(false);
    glueLeft = input<boolean>(false);

    onClick = output<MouseEvent>();

    @HostBinding('class.fluid')
    get hostFluidClass() {
        return this.fluid();
    }
}
